import * as React from 'react';

const SvgFire = (props) => (
  <svg
    width={56}
    height={56}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M45.615 25.679a19.002 19.002 0 0 0-4.534-6.3l-1.591-1.46a.442.442 0 0 0-.711.18l-.711 2.04c-.443 1.28-1.258 2.586-2.412 3.872a.342.342 0 0 1-.224.109.302.302 0 0 1-.235-.082.321.321 0 0 1-.11-.263c.203-3.292-.782-7.005-2.936-11.046-1.783-3.358-4.26-5.978-7.356-7.804l-2.258-1.33a.438.438 0 0 0-.656.4L22 6.62c.082 1.794-.126 3.38-.618 4.698a15.595 15.595 0 0 1-2.57 4.457 16.165 16.165 0 0 1-2.598 2.52 19.283 19.283 0 0 0-5.485 6.645 19.017 19.017 0 0 0-1.98 8.439c0 2.58.509 5.08 1.515 7.437a19.107 19.107 0 0 0 4.129 6.065 19.212 19.212 0 0 0 6.12 4.085A19.241 19.241 0 0 0 28 52.464c2.598 0 5.113-.503 7.487-1.492a19.065 19.065 0 0 0 6.12-4.086 18.932 18.932 0 0 0 5.643-13.502c0-2.669-.547-5.26-1.635-7.705Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgFire;
